var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWildBoar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #757575;\r\n        stroke: #fff;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.25,39l-2,2-.5,.5,1,2.5h2.5l2-.5h4l2.5-1-2,2-.5,2.5-1,2,.5,3,1,2.5,1.5-1,1-1v-1.5h1l.5-1-.5-1-.5-1,1.5-.5,1.5-1.81h3l1,.31,2,2.5,.5,1.5v1.5l-1,1.5-1,1.5,1.5,1.5h1.5l1-1,1-.5,1,.5,1-.81-.5-1.69-1-1v-2l-.5-3,2.5,.5,3-.5,2.5-.81,2.5,.31-2.5,1-3,2-1,2.5v2l1.5,1,1-1h2l.5-3,1-.5,2.5-.5,2.5-1,1.5-1-1.5-2,.5-1,4,2.5,3.5,.5,2,1.5,1.5,2.5v1l-1.5,1-.5,2,1,.5h2.5l.5-1.5h2v-1.5l.5-2-.5-2-1.5-2-2.5-3-2.5-2-1-5,1-1,2.5-2.5,2.5-.5,2.5-.5,1.5-1-1-2-4.5-.5-3.5,1-2.5-.5-6-1-4.5-1.5-5.5-2-8.5-.5h-3.5l-5,2h-3l-1.5-2-1.5-.5-1,2.5,1,3-1,2-1.5,3.5-3,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWildBoar);
export default __webpack_public_path__ + "static/media/wild-boar.75ec8f10a530cf2904ddc26cc1f88473.svg";
export { ForwardRef as ReactComponent };